class ProductAccordionDescription {
  setupListeners () {
    const readMore = document.querySelector('[href="#ProductDescription"]')
    if (!readMore) return

    this.accordionDescription = document.querySelector('#ProductDescription')
    if (!this.accordionDescription) {
      readMore.style.display = 'none'
      return
    }

    readMore.addEventListener('click', () => this.slideToDescription())
  }

  slideToDescription () {
    const parent = this.accordionDescription.parentElement

    window.setTimeout(() => {
      if (parent.getAttribute('aria-expanded') !== 'true') {
        this.accordionDescription.click()
      }
    }, 300)
  }
}

new ProductAccordionDescription().setupListeners()
